import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@saridana-core/react-ui-kit";
import { TFaq } from "@shared/types";
import { HtmlParser } from "@shared/ui";
export function FaqSearchDialog(t0) {
  const $ = _c(12);
  const {
    faq,
    onOpenChange
  } = t0;
  const t1 = !!faq;
  const t2 = !!faq;
  const t3 = faq?.attributes?.title;
  let t4;
  if ($[0] !== t3) {
    t4 = <DialogHeader><DialogTitle className="text-left pr-10">FAQ: {t3}</DialogTitle></DialogHeader>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = faq?.attributes?.description;
  let t6;
  if ($[2] !== t5) {
    t6 = <div><HtmlParser data={t5} /></div>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4 || $[5] !== t6) {
    t7 = <DialogContent className="sm:max-w-[40vw] p-6">{t4}{t6}</DialogContent>;
    $[4] = t4;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== onOpenChange || $[8] !== t1 || $[9] !== t2 || $[10] !== t7) {
    t8 = <Dialog defaultOpen={t1} open={t2} onOpenChange={onOpenChange}>{t7}</Dialog>;
    $[7] = onOpenChange;
    $[8] = t1;
    $[9] = t2;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}